import React, { useState } from "react";
import TermsContent from "../../../../components/ui/TermsContent";

const isTrue = (v) => v === "1";
const yesNo = (v) => (isTrue(v) ? "True" : "False");

const FIELDS = [
    { label: "Product", value: (e) => e.ProductName1 },
    { label: "Age From", value: (e) => e.AgeFrom },
    { label: "Age To", value: (e) => e.AgeTo },
    { label: "Children", value: (e) => yesNo(e.CanHaveChildren) },
    { label: "Spouse", value: (e) => yesNo(e.CanHaveSpouse) },
    { label: "Extended", value: (e) => yesNo(e.Extended) },
    { label: "Waiting Period", value: (e) => e.DefaultWaiting },
    { label: "Currency", value: (e) => e.CurrencyType },
    { label: "Total Price", value: (e) => e.Total },
    { label: "Product ID", value: (e) => e.ProductID },
    { label: "Franchise ID", value: (e) => e.FranchiseID },
    { label: "Benefits", value: (e) => e.BenefitsText },
];

const Flag = ({ label, on }) => (
    <span className={`badge badge-sm ${on ? "badge-success badge-outline" : "badge-ghost"}`}>
        {label} {on ? "✓" : "✕"}
    </span>
);

const ViewProduct = ({ onCloseDialog, rowData }) => {
    const [viewMode, setViewMode] = useState("grid");
    const products = rowData?.planProducts || [];
    const groupName = rowData?.easipolPolicySubGroup?.Description;

    return (
        <div className="grid grid-cols-1 md:grid-cols-[18rem_minmax(0,1fr)] border border-base-200 rounded-box overflow-hidden">
            {/* Group details rail */}
            <aside className="bg-base-200/60 p-5 flex flex-col gap-4 md:border-r border-base-200">
                {rowData?.groupImageBannerUrl ? (
                    <img src={rowData.groupImageBannerUrl} alt="Group Artwork" className="w-full aspect-[3/2] object-cover rounded-box" />
                ) : (
                    <div className="w-full aspect-[3/2] rounded-box bg-base-300 flex items-center justify-center text-sm text-base-content/50">
                        No Group Artwork
                    </div>
                )}
                <div>
                    <h3 className="text-lg font-bold leading-tight">{groupName}</h3>
                    <div className="flex flex-wrap gap-2 mt-2">
                        {rowData?.category && <span className="badge badge-primary badge-outline">{rowData.category}</span>}
                        {rowData?.activeStatus !== undefined && (
                            <span className={`badge ${rowData.activeStatus ? "badge-success" : "badge-ghost"}`}>
                                {rowData.activeStatus ? "Active" : "Inactive"}
                            </span>
                        )}
                    </div>
                </div>
                <dl className="flex flex-col gap-3 text-sm">
                    <div>
                        <dt className="text-xs uppercase tracking-wide font-semibold text-base-content/60">Products</dt>
                        <dd>{products.length}</dd>
                    </div>
                    {rowData?.termAndConditions && (
                        <div>
                            <dt className="text-xs uppercase tracking-wide font-semibold text-base-content/60">Terms &amp; Conditions</dt>
                            <dd>
                                <TermsContent text={rowData.termAndConditions} className="text-base-content/70 max-h-40 overflow-y-auto" />
                            </dd>
                        </div>
                    )}
                </dl>
            </aside>

            {/* Products */}
            <section className="p-5 min-w-0">
                <div className="flex items-center justify-between mb-3">
                    <h4 className="font-bold">Products ({products.length})</h4>
                    <div className="join">
                        <button type="button" className={`btn btn-sm join-item ${viewMode === "table" ? "btn-primary" : "btn-ghost border-base-300"}`} onClick={() => setViewMode("table")}>
                            <i className="pi pi-list"></i> Table
                        </button>
                        <button type="button" className={`btn btn-sm join-item ${viewMode === "grid" ? "btn-primary" : "btn-ghost border-base-300"}`} onClick={() => setViewMode("grid")}>
                            <i className="pi pi-th-large"></i> Cards
                        </button>
                    </div>
                </div>

                {(products.length === 0) && (<div className="text-center text-base-content/60 py-10">No products in this group</div>)}
                {products.length !== 0 && (viewMode === "table") && (<div className="overflow-x-auto">
                        <table className="table table-zebra table-sm">
                            <thead>
                                <tr>{FIELDS.map((f) => <th key={f.label}>{f.label}</th>)}</tr>
                            </thead>
                            <tbody>
                                {products.map((element) => (
                                    <tr key={element.ProductID}>
                                        {FIELDS.map((f) => <td key={f.label}>{f.value(element)}</td>)}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>)}
                {products.length !== 0 && viewMode !== "table" && (<div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-3">
                        {products.map((element) => (
                            <div key={element.ProductID} className="card card-compact bg-base-100 border border-base-200 hover:shadow">
                                <div className="card-body gap-2">
                                    <h5 className="font-semibold text-sm leading-snug">{element.ProductName1}</h5>
                                    <div className="text-2xl font-bold text-primary">
                                        {element.CurrencyType} {element.Total}
                                    </div>
                                    <p className="text-xs text-base-content/70">{element.BenefitsText}</p>
                                    <div className="flex flex-wrap gap-1">
                                        <span className="badge badge-sm badge-ghost">Age {element.AgeFrom}–{element.AgeTo}</span>
                                        <span className="badge badge-sm badge-ghost">Waiting {element.DefaultWaiting}</span>
                                        <Flag label="Children" on={isTrue(element.CanHaveChildren)} />
                                        <Flag label="Spouse" on={isTrue(element.CanHaveSpouse)} />
                                        <Flag label="Extended" on={isTrue(element.Extended)} />
                                    </div>
                                    <div className="flex justify-between border-t border-dashed border-base-300 pt-2 text-xs font-mono text-base-content/60">
                                        <span>PID {element.ProductID}</span>
                                        <span>FID {element.FranchiseID}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>)}
            </section>
        </div>
    );
};

export default ViewProduct;
